import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { format, parseISO } from "date-fns";
import { id as idLocale } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";

export function DateField({ value, onChange, testid, placeholder = "Pilih tanggal" }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid} className="w-full justify-start text-left font-normal rounded-xl bg-white h-12 hover:bg-white">
          <CalendarIcon size={16} className="mr-2 text-stone-400 shrink-0" />
          {selected ? format(selected, "d MMMM yyyy", { locale: idLocale }) : <span className="text-stone-400">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          locale={idLocale}
          defaultMonth={selected}
          onSelect={(d) => { if (d) onChange(format(d, "yyyy-MM-dd")); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
